module.exports = __webpack_public_path__ + "assets/img/1209.0a46967b.png";